import React from 'react';

import { TFunction } from '@lyearn/i18n';
import { Typography } from '@lyearn/ui';
import { Image } from '@/components/Image';
import { EXTERNAL_CONTENT_TYPE_LABEL } from '@/modules/corporate/modules/external-content/views/ExternalContentEditor/components/Editor/const';
import { ExternalContentTypeEnum } from '@/types/schema';

type ProviderImageOverrides = {
  className?: string;
  width?: number;
  height?: number;
};

export const renderProviderImage = (
  alt: string,
  url?: string | null,
  overrides?: ProviderImageOverrides,
) => {
  if (!url) {
    return null;
  }

  return (
    <Image
      alt={alt}
      className={overrides?.className || 'h-16 w-16 rounded-4'}
      height={overrides?.height || 16}
      src={url}
      width={overrides?.width || 16}
    />
  );
};

export const renderExternalContentType = (
  t: TFunction,
  externalContentType?: ExternalContentTypeEnum | null,
) => {
  if (!externalContentType) {
    return null;
  }

  return (
    <Typography color="text-text-secondary" variant="body-short-02">
      {t(EXTERNAL_CONTENT_TYPE_LABEL[externalContentType])}
    </Typography>
  );
};
